import React, { useState, useRef } from "react";
import { useCurrentPng } from "recharts-to-png";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { useReactToPrint } from "react-to-print";
import CustomButton from "./button";
import { getTimeDifference } from "../common";

const BottomLabel = ({ x, y, value, stroke }) => {
    return (
        <text
            x={x}
            y={y + 15} // Position label below the point
            fill={stroke}
            fontSize={12}
            textAnchor="middle"
        >
            {value}
        </text>
    );
};

export default function ExcelChart() {
    const [data, setData] = useState([]);
    const [isLoading, setISLoading] = useState(false)
    const [getPng, { ref }] = useCurrentPng();


    const [upDownTime, setUpDownTime] = useState({})

    // For printing
    const printRef = useRef();

    // Handle PNG download
    const handleDownload = async () => {

        setISLoading(true)
        const png = await getPng();

        console.log(png, 'hire');
        if (png) {
            FileSaver.saveAs(png, "my-chart.png");
            setISLoading(false)
        }
    };

    const excelSerialToTime24 = (serial) => {
        const fractionalDay = serial - Math.floor(serial); // Only fractional part for time
        const totalSeconds = Math.round(fractionalDay * 86400); // 24 * 60 * 60

        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`; // 24-hour format
    };

    const getUpDownTime = (data) => {

        console.log(data, 'hi');

        let times = {
            General_Analog_RTD_1_UP: null,
            General_Analog_RTD_1_DOWN: null,
            General_Analog_RTD_1_HOLD: null,
            General_Analog_RTD_2_UP: null,
            General_Analog_RTD_2_DOWN: null,
            General_Analog_RTD_2_HOLd: null
        }


        data.forEach((dat) => {

            if (dat?.General_Analog_RTD_1 >= 70 && !times?.General_Analog_RTD_1_UP) {
                times.General_Analog_RTD_1_UP = dat?.TimeString
            }

            if (!times?.General_Analog_RTD_1_DOWN && times?.General_Analog_RTD_1_UP && dat?.General_Analog_RTD_1 <= 70) {
                times.General_Analog_RTD_1_DOWN = dat?.TimeString
            }


            if (dat?.General_Analog_RTD_2 >= 70 && !times?.General_Analog_RTD_2_UP) {
                times.General_Analog_RTD_2_UP = dat?.TimeString
            }

            if (!times?.General_Analog_RTD_2_DOWN && times?.General_Analog_RTD_2_UP && dat?.General_Analog_RTD_2 <= 70) {
                times.General_Analog_RTD_2_DOWN = dat?.TimeString
            }


        })

        let General_Analog_RTD_1_HOLD = getTimeDifference(times?.General_Analog_RTD_1_UP, times?.General_Analog_RTD_1_DOWN)
        let General_Analog_RTD_2_HOLD = getTimeDifference(times?.General_Analog_RTD_2_UP, times?.General_Analog_RTD_2_DOWN)

        times.General_Analog_RTD_1_HOLD = `${General_Analog_RTD_1_HOLD?.hours}.${General_Analog_RTD_1_HOLD?.minutes}.${General_Analog_RTD_1_HOLD?.seconds}`

        times.General_Analog_RTD_2_HOLD = `${General_Analog_RTD_2_HOLD?.hours}.${General_Analog_RTD_2_HOLD?.minutes}.${General_Analog_RTD_2_HOLD?.seconds}`

        setUpDownTime(times)


    }


    // Handle Excel file upload
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });

            // Get the third sheet
            const sheetName = workbook.SheetNames[2];
            const sheet = workbook.Sheets[sheetName];

            // Convert sheet to JSON
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            // Transform Row Labels to readable time
            const transformedData = jsonData.map(row => ({
                ...row,
                TimeString: excelSerialToTime24(row["Row Labels"]).toLocaleString() // Add readable timestamp
            }));

            console.log("Transformed Data --->", transformedData);

            getUpDownTime(transformedData)

            setData(transformedData);
        };

        reader.readAsBinaryString(file);
    };


    // Fix: `content` should return `printRef.current`
    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: "Chart Print",
        pageStyle: `
      @page {
        size: A4;
        margin: 20mm;
      }
      body {
        font-family: Arial, sans-serif;
      }
      .chart-container {
        width: 100%;
        height: 100%;
      }
    `,
    });

    return (
        <div className="candListBox" >
            <h2 className="font-size-h3 font-bold mb-4 mt-2">Excel Data Chart</h2>

            <div className="d-flex align-items-center justify-content-between">
                <input
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    onChange={handleFileUpload}
                    className="mb-6"
                />

                <div style={{ display: "flex", gap: "10px", paddingRight: '50px', paddingBottom: "20px" }}>
                    <CustomButton
                        title={isLoading ? "Generating image..." : "Download Chart"}
                        handleClick={() => {
                            setISLoading(true)
                            handleDownload()

                        }}
                        isLoading={isLoading}
                    />
                    <CustomButton
                        title={"Print Chart"}
                        handleClick={handlePrint}
                    />

                </div>
            </div>
            <div>
                {data.length > 0 && (
                    <div
                        className="d-flex justify-content-center align-items-center flex-column w-100"
                        ref={printRef}
                        style={{
                            width: '100%',
                        }}

                    >
                        <ResponsiveContainer ref={ref} width={784} height={400}>
                            <LineChart data={data}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="TimeString" />
                                <YAxis />
                                <YAxis yAxisId="right" orientation="right" dataKey={'General_Analog_Pressure_Transmitter'}
                                    label={{
                                        value: "General Analog Pressure Transmitter",
                                        angle: 90, // Rotate vertically
                                        position: "insideRight", // Position inside the right Y-Axis
                                        style: { textAnchor: "middle", fill: "#000", fontSize: 14 } // Optional styles
                                    }}
                                />
                                <Tooltip />
                                <Legend />

                                {/* Lines for each sensor */}
                                {/* <Line type="monotone" dataKey="General_Analog_Pressure_Transmitter" stroke="blue" /> */}
                                <Line type="monotone" dataKey="General_Analog_RTD_2" stroke="green" />
                                <Line type="monotone" dataKey="General_Analog_RTD_1" stroke="#8884d8" />
                            </LineChart>

                        </ResponsiveContainer>
                        <div className="d-flex gap-3 mt-2">
                            <div className="p-1">
                                <h6 style={{ color: '#8884d8' }}> General_Analog_RTD_1 </h6>
                                <h6 style={{ color: '#8884d8' }}>UP_TIME : {upDownTime?.General_Analog_RTD_1_UP}</h6>
                                <h6 style={{ color: '#8884d8' }}> DOWN_TIME : {upDownTime?.General_Analog_RTD_1_DOWN}</h6>
                                <h6 style={{ color: '#8884d8' }}>HOLD TIME : {upDownTime?.General_Analog_RTD_1_HOLD}</h6>
                            </div>
                            <div className="p-1">
                                <h6 style={{ color: 'green' }}> General_Analog_RTD_2</h6>
                                <h6 style={{ color: 'green' }}> UP_TIME : {upDownTime?.General_Analog_RTD_2_UP}</h6>
                                <h6 style={{ color: 'green' }}>  DOWN_TIME : {upDownTime?.General_Analog_RTD_2_DOWN}</h6>
                                <h6 style={{ color: 'green' }}>  HOLD TIME : {upDownTime?.General_Analog_RTD_2_HOLD}</h6>
                            </div>
                        </div>
                    </div>

                )}
            </div>
        </div>
    );
}
